import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp1011',
    ecrans: ['00-2'],
    params: ['?concleint']
});
